//core
import React, { useState,useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
// import withStyles from "@material-ui/core/styles/withStyles";
//material-ui
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Close from "@material-ui/icons/Close";
//material-ui/icon
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
// import DoneIcon from '@material-ui/icons/Done';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
// import StopIcon from '@material-ui/icons/Stop';
import ExtensionIcon from '@material-ui/icons/Extension';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import FolderIcon from '@material-ui/icons/Folder';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
// import Tooltip from '@material-ui/core/Tooltip';
// import ReactTable from "react-table";
//dashboard-pro
import Button from "components/CustomButtons/Button.jsx";
//components
import CheckboxTree from 'react-checkbox-tree';
import PerfectScrollbar from "perfect-scrollbar";
//business
// import CommonHttp from "businessComponents/CommonHttp";
// import {GRID_CELL_WIDTH,LongTextCell} from "businessComponents/config";
// import { GlobalContext } from 'businessComponents/Global/Global.context.js';
//css
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.jsx";
import { infoColor } from "assets/jss/material-dashboard-pro-react.jsx";
import CommonHttp from './CommonHttp';
import { requestTry } from './utils';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

const costDetailModalStyle = makeStyles(theme => ({
  ...modalStyle,
  modal: {
    [theme.breakpoints.down("lg")]: {
      maxWidth: "600px",
      margin: "auto"
    },
    [theme.breakpoints.up("lg")]: {
      maxWidth: "900px",
      margin: "auto"
    },
  },
  customIcon:{color:infoColor[0]},
  customLeafIcon:{color:infoColor[3]}
}))

// eslint-disable-next-line no-unused-vars
let ps;
let supplyClassId = {};

function CostDetailModal(props){
    const classes = costDetailModalStyle();
    const [nodes, setnodes] = useState([])
    const [checked, setchecked] = useState([]);
    const [expanded, setexpanded] = useState([]);
    const [showname, setshowname] = useState([]);

    const [showModal, setShowModal] = useState(false);
  
    // 选择逻辑一层判断选/反选
    // 二层判断是否顶层（所有分类）
    // 顶层只有一个名称
    
    const handleChildren = (children,nameList) => {
        // let name = showname;
        children.map(prop => {
            if (prop.children && prop.children.length > 0) {//这就是父级中的父级
                nameList = checkNameArr(prop.name,nameList);
                nameList = handleChildren(prop.children,nameList)
            }
            return prop;
        })
        return nameList;
    }

    const unCheckChildren = (children,nameList) => {
        children.map(prop => {
            if (prop.children && prop.children.length > 0) {//这就是父级中的父级
                unCheckNameArr(prop.name,nameList);
                nameList = unCheckChildren(prop.children,nameList)
            }
            return prop;
        })
        return nameList;
    }
    
    const checkNameArr = (curName,nameList) => {
        let index = nameList.findIndex(el => {
            return el === curName;
        });
        if (index === -1) {
            nameList.push(curName);
        }
        return nameList;
    }

    const unCheckNameArr = (curName,nameList) => {
        let index = nameList.findIndex(el => {
            return el === curName;
        });
        if (index !== -1) {
            nameList.splice(index,1);
        }
        return nameList;
    }

    const checkRepeatChildren = (arr,name) => {
        if (arr.children && arr.children.length > 0) {
            for (let j = 0; j < arr.children.length; j++) {
                checkRepeatChildren(arr.children[j],name)
            }
        }else{
            let alreadyHas = false;
            for (let k = 0; k < checked.length; k++) {
                // eslint-disable-next-line eqeqeq
                if (checked[k] == arr.id) {
                    alreadyHas = true
                }
            }
            if (!alreadyHas) {
                name.push(arr.showName?arr.showName:arr.label);
            }
        }
    }
    
    const checkNode = (checkedNode,targetNode) => {
        // console.log(checked);
        // console.log(targetNode);
        let resultName;//resultName用于显示在表单中
        let name = showname;//名称数组用于逻辑操作
        //选择地区的时候只显示省、直辖市一级
        //请求回来的数据中都增加了showname为当前市区所在省级的名称
        //每选中一个末级节点，就往name数组里添加一个showname
        //反选时同样，每取消一个末级节点，都从name数组中删除一个showname
        //最终将name数组去重，并用短线拼接，展示在页面上
        if (props.type === 'companysendareaids') {//地区逻辑
            if (targetNode.checked) {//选择
                if(targetNode.treeDepth < 3){//小于3就是父级，3为子集。一旦树结构变化，这里需要改动
                    checkRepeatChildren(targetNode,name);
                }else{
                    name.push(targetNode.parent.showName ? targetNode.parent.showName : targetNode.label);
                }
                // //名称只显示showname
                // if (targetNode.parent.showName) {//有showname就用，没有就用自己的label
                //     // resultName = checkNameArr(targetNode.parent.showName,name);
                //     name.push(targetNode.parent.showName);
                //     // resultName = name;
                // } else {
                //     // resultName = checkNameArr(targetNode.label,name);
                //     name.push(targetNode.label);
                //     // resultName = name;
                // }
            }else{//反选
                if (targetNode.treeDepth === 0) {//反选了全部
                    name = [];
                }else if (targetNode.treeDepth < 3) {//小于3就是父级，3为子集。一旦树结构变化，这里需要改动
                    //获取取消选择了多少个
                    let uncheckedCount = checked.length - checkedNode.length;
                    //批量选择，他们显示的名称都是一样的
                    let curShowName = (targetNode.parent && targetNode.parent.showName) ? targetNode.parent.showName : targetNode.label;
                    //去循环已有的名称数组，取消了几个，就删除几个
                    for (let g = 0; g < uncheckedCount; g++) {
                        let m = name.findIndex(el => {
                            return el === curShowName;
                        })
                        if (m > -1) {
                            name.splice(m,1);
                        }
                    }
                } else {
                    unCheckNameArr(targetNode.parent.showName,name);
                }
                
                // if (targetNode.parent.showName) {//有showname就用，没有就用自己的label
                //     name = unCheckNameArr(targetNode.parent.showName,name);
                // } else {
                //     name = unCheckNameArr(targetNode.label,name);
                // }
            }
            // resultName = Array.from(new Set(name)).join();
        } else {//分类逻辑
            //分类逻辑，只显示父级节点，当前业务，树最多分三级
            //也就是可能要展示一级、二级的节点
            //然后这里的处理逻辑，我是真忘了
            if (targetNode.checked) {//选择节点
                if (targetNode.children && targetNode.children.length > 0) {//选择了父级
                    name = checkNameArr(targetNode.label,name);
                    name = handleChildren(targetNode.children,name);
                } else {//选择了子集
                    // name = checkNameArr(targetNode.parent.name,name);
                    name.push(targetNode.parent.name);
                }
            }else{//反选节点
                // let index;
                if (targetNode.children && targetNode.children.length > 0) {//反选了父级
                    name = unCheckNameArr(targetNode.label,name);
                    name = unCheckChildren(targetNode.children,name);
                } else {
                    name = unCheckNameArr(targetNode.parent.name,name);
                }
            }
            // console.log(name);
            // setshowname(name);
            // setchecked(checked)
            let lastIndex = name.findIndex(el => {
                return el === '所有分类';
            });
            if (lastIndex !== -1) {
                name.splice(lastIndex,1);
            }
            // name = name.filter()
            //对name数组去重
            //todo
            // resultName = name.join();
            // console.log(name);
            // resultName = Array.from(new Set(name)).join();
            // [].filter()
            // resultName = [].filter.call(resultName,(s,i,o)=>o.indexOf(s)===i).join('');
            // console.log(resultName);
        }
        // console.log(name);
        setshowname(name);
        resultName = Array.from(new Set(name)).join();
        // console.log(resultName);
        setchecked(checkedNode)
        props.selectTree(checkedNode.join(','),resultName);
    }

    const expandedNode = expanded => {
        setexpanded(expanded);
    }

    //data是请求回来的数据
    //nodes页面上已保存的已选数据
    const formatTreeData = (data,nodes,resultArr) => {
        if (Array.isArray(data)) {
            data.map((prop,key) => {
                if (prop.children && prop.children.length > 0) {
                    formatTreeData(prop.children,nodes,resultArr);
                }
                prop.value = prop.id;
                prop.label = prop.name;
                for (let k = 0; k < nodes.length; k++) {
                    // eslint-disable-next-line eqeqeq
                    if (nodes[k] == prop.id) {
                        resultArr.push(prop.value);
                        //整体保存之前都不存在灰化的需求
                        //因此注册中不用灰化，灰化放在供方后台
                        // prop.disabled = true;
                    }
                }
                return prop;
            })
        } else {
            formatTreeData([data]);
        }
    }
    
    const selectConfirm = () => {
        if (props.selectConfirm) {
            props.selectConfirm(supplyClassId);
            setShowModal(false);
        }else{
            setShowModal(false);
        }
    }

    const handleProvince = data => {
        //第一层children就是省份，也是最终需要显示的内容
        data[0].label = data[0].name;
        data[0].value = data[0].id;
        data[0].children.map(prop => {
            prop.label = prop.name;
            prop.value = prop.id;
            prop.showName = prop.name;
            if (prop.children && prop.children.length > 0) {//市级以下的处理逻辑是一样的
                handleCityAndOther(prop.children,prop.showName);
            }
            return prop;
        })
    }

    const handleCityAndOther = (data,showName) => {
        data.map(prop => {
            prop.showName = showName;
            prop.label = prop.name;
            prop.value = prop.id;
            if (prop.children && prop.children.length > 0) {//市级以及区
                handleCityAndOther(prop.children,prop.showName);
            }
            return prop;
        })
    }

    const handleSupplyClass = (data) => {
        //把六大类的id这边存一下
        supplyClassId = {};
        data[0].children.forEach(element => {
            supplyClassId[element.id] = element.name;
        });
    }

    useEffect(() => {
        if (showModal) {
            ps = new PerfectScrollbar('#tree-modal-content', {
                suppressScrollX: true,
                suppressScrollY: false
            });
            let url = props.type === 'companysendareaids' ? '/areas/tree' : '/sysCategory/tree?type=1';
            requestTry(CommonHttp.get(url)).then(res => {
                let resultData = [];
                resultData.push(res);
                if (props.type === 'companysendareaids') {//送货区域
                    handleProvince(resultData);
                    if (props.selectedNode) {//如果已经保存过，设定勾选
                        setchecked(props.selectedNode.split(','));
                    }
                    if (props.selectedNodeText){//如果已经保存过，设定回显文字
                        setshowname(props.selectedNodeText.split(','));
                    }
                } else {//供货类别
                    let alreadyChecked = []
                    handleSupplyClass(resultData);
                    formatTreeData(resultData,props.selectedNode.split(','),alreadyChecked);
                    if (alreadyChecked.length > 0) {//如果已经保存过，设定勾选
                        setchecked(alreadyChecked);
                    } 
                    if (props.selectedNodeText) {//如果已经保存过，设定回显文字
                        setshowname(props.selectedNodeText.split(','));
                    } 
                }
                setnodes(resultData);
            },err => {
                props.openSnackbar(err);
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showModal])

    return (
        <React.Fragment>
            <Button style={{marginTop:'15px'}} size='sm' color="info" onClick={ () => {setShowModal(true)} }>点击选择</Button>
            <Dialog classes={{root:classes.center,paper:classes.modal}} 
                open={showModal} transition={Transition} maxWidth='lg'
                fullWidth={true} keepMounted
                onClose={() => {setShowModal(false)}}
                aria-labelledby="modal-slide-title"
                aria-describedby="modal-slide-description">
                <DialogTitle id="classic-modal-slide-title"disableTypography className={classes.modalHeader}>
                    <Button justIcon aria-label="Close" key="close" color="transparent"
                    className={classes.modalCloseButton}
                    onClick={() => {setShowModal(false)}}>
                        <Close className={classes.modalClose} />
                    </Button>
                    <h4 className={classes.modalTitle}>{props.modalTitle}</h4>
                </DialogTitle>
                <DialogContent style={{height:'calc(100vh - 400px)',overflow:'auto'}} id="tree-modal-content" className={classes.modalBody}>
                    {props.type === 'supplierClass' ? (<h6 className="warning-text">供货小类选择请与营业执照经营范围保持一致，否则将被退回，请谨慎选择!</h6>) : ''}
                    <CheckboxTree nodes={nodes} 
                        checked={checked}
                        expanded={expanded}
                        onCheck={checkNode}
                        onExpand={expandedNode}
                        onlyLeafCheckboxes={props.type === 'supplierClass'}
                        icons={{
                            check:<CheckBoxIcon fontSize='small' />,
                            halfCheck:<IndeterminateCheckBoxIcon fontSize='small' />,
                            uncheck:<CheckBoxOutlineBlankIcon fontSize='small' />,
                            expandClose: <KeyboardArrowRightIcon fontSize='small' />,
                            expandOpen: <KeyboardArrowDownIcon fontSize='small' />,
                            leaf:<ExtensionIcon className={classes.customLeafIcon} fontSize='small' />,
                            parentClose: <FolderIcon className={classes.customIcon} fontSize='small' />,
                            parentOpen: <FolderOpenIcon className={classes.customIcon} fontSize='small' />,
                        }}/>
                </DialogContent>
                <DialogActions className={classes.modalFooter +" " +classes.modalFooterCenter}>
                    <Button onClick={selectConfirm} color="success">确定</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default CostDetailModal;